<template>
  <div class="general">
  <div v-if="spinner"  style="height:65vh; " class="d-flex align-items-center">
    <Spinner/>
  </div>
    <form v-else class="mb-5">
      <div class="row">
        <div class="col-lg-4 left-general">
          <label class="sum-point">Currency</label><br>
          <input v-model="currency" class="form-input cashback-input " placeholder="USD">
          <label v-if="id === '677fabe0e4744e4d2baa50e2'" class="sum-point">Currency Rate</label><br>
          <input v-if="id === '677fabe0e4744e4d2baa50e2'" v-model="currencyRate" class="form-input cashback-input " placeholder="0.75">

          <label class="sum-point">Your country</label>
          <select v-model="country" class="form-control long-form-control  form-control-lg " aria-label=".form-select-lg example">
            <option val="Kyrgyzstan">Kyrgyzstan</option>
            <option val="Russia">Russia</option>
            <option val="USA">USA</option>
            <option val="USA">Kazakhstan</option>
          </select>
          <label class="sum-point">Name of the company</label><br>
          <input v-model="name" class="form-input cashback-input " placeholder="Company">
          <label class="sum-point">Email</label><br>
          <input v-model="email" class="form-input cashback-input " placeholder="Company email">
          <h2 class="cashback-title mt-3">
            Chat settings
          </h2>
          <div class="d-flex enable-title">
            <label class="switch d-flex">
              <input v-model="chat" type="checkbox" >
              <span class="slider round"></span>
            </label>
            <h2 class="cashback-sub-title">Chat</h2>
          </div>
          <p class="cashback-description mb-5">Disables the ability to write to you in the chat</p>

          <h2 class="cashback-title mt-3">
            Order notification
          </h2>
          <div class="d-flex enable-title">
            <label class="switch d-flex">
              <input v-model="notificate" type="checkbox" >
              <span class="slider round"></span>
            </label>
            <h2 class="cashback-sub-title">Notificate</h2>
          </div>
          <p class="cashback-description mb-5">Letters about new orders will come to the specified mails</p>

          <h2 class="cashback-sub-title">Mails</h2>
          <div class="d-flex flex-wrap pb-4">
            <div class="custom-fields col-12 pr-0 pl-0 d-flex align-items-center my-2">
              <input v-model="newMail" class="form-input cashback-input" placeholder="Email">
              <button style="margin-top: -20px; margin-left: -10px; border: 1px solid rgba(97, 108, 245, 1);" type="button" @click="addNewMail" class="discount-btn ml-2"><img style="padding: 5px;" src="../../assets/icons/enable+.svg"></button>
            </div>
            <div class="custom-fields col-12 pr-0 pl-0" v-for="(mail, index) in mails" :key="index" >
              <div class="d-flex">
                <input v-model="mails[index]" class="form-input cashback-input mb-2" placeholder="field value">
                <button type="button" @click="removeVal('mails', index)" class="discount-btn ml-2"><img alt="x" src="../../assets/icons/x.svg"></button>
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-8 ">
          <div>
            <h2 class="cashback-title mt-3">
              Registration and authorization settings
            </h2>
            <div class="d-flex enable-title">
              <h2 class="cashback-sub-title">Methods</h2>
            </div>
            <p class="cashback-description mb-3">Here you can customize Registration and authorization methods</p>
            <div class="row mb-4 justify-content-between branch_list_item">
              <div class="col-md-4  d-flex justify-content-center">
                <div :class="['validity-period', { active: authMethods.email.enabled }]" @click="selectAuthMethod('email')" class="w-100">
                  <div class="d-flex align-items-center">
                    <div class="round-price">
                    </div>
                    <h3 class="validity-title">by email</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-flex justify-content-center">
                <div :class="['validity-period', { active: authMethods.phone.enabled }]"  @click="selectAuthMethod('phone')" class="w-100">
                  <div class="d-flex align-items-center">
                    <div class="round-price">
                    </div>
                    <h3 class="validity-title">by phone</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-flex justify-content-center">
                <div :class="['validity-period', { active: authMethods.googleAppleID.enabled }]" @click="selectAuthMethod('googleAppleID')" class="w-100">
                  <div class="d-flex align-items-center">
                    <div class="round-price">
                    </div>
                    <h3 class="validity-title">by Google/Apple ID</h3>
                  </div>
                </div>
              </div>
            </div>
            <p class="cashback-description mb-3">In case of registration and authorization by mail. Fields: email and password are required. The remaining fields are editable</p>
            <div class="mb-4 justify-content-between">
              <div class="row mb-4 justify-content-between">
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('fullName')" @click="toggleField('fullName')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Name</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('phone')" @click="toggleField('phone')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Phone</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('email')" @click="toggleField('email')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Email</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-4 justify-content-between">
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('password')" @click="toggleField('password')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Password</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('additionalFields')" @click="toggleField('additionalFields')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Custom Fields</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 d-flex justify-content-center">
                  <div class="w-100" :class="fieldClass('googleAppleID')" @click="toggleField('googleAppleID')">
                    <div class="d-flex align-items-center">
                      <div class="round-price">
                        <img src="../../assets/icons/bird.svg" class="no-pointer">
                      </div>
                      <h3 class="validity-title">Google & Apple ID</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2 class="cashback-title mt-3">
              Custom fields settings
            </h2>
            <div class="d-flex enable-title">
              <label class="switch d-flex">
                <input v-model="customFields" type="checkbox" >
                <span class="slider round"></span>
              </label>
              <h2 class="cashback-sub-title">Fields</h2>
            </div>
            <p class="cashback-description mb-5">Disables the ability to write to you in the chat</p>
            <h2 class="cashback-sub-title">First field</h2>
            <div class="d-flex flex-wrap ">
              <div class="custom-fields col-12 pr-0 pl-0 d-flex align-items-center my-2">
                <input v-model="custom_field_0.fieldName" class="form-input cashback-input  mr-3" placeholder="field name">
                <label class="switch d-flex">
                  <input v-model="custom_field_0.required" type="checkbox" >
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="custom-fields col-12 pr-0 pl-0" v-for="(item, index) in custom_field_0.values" :key="index" >
                <div class="d-flex" v-if="custom_field_0.fieldName.length">
                  <input v-model="custom_field_0.values[index]" class="form-input cashback-input mb-2" placeholder="field value">
                  <button v-if="index == 0" type="button" @click="addNewVal('custom_field_0')" class="discount-btn ml-2"><img src="../../assets/icons/enable+.svg"></button>
                  <button v-if="index != 0" type="button" @click="removeVal('custom_field_0', index)" class="discount-btn ml-2"><img alt="x" src="../../assets/icons/x.svg"></button>
                </div>
              </div>
            </div>
            <h2 class="cashback-sub-title mt-3">Second field</h2>
            <div class="d-flex flex-wrap ">
              <div class="custom-fields col-12 pr-0 pl-0 d-flex align-items-center my-2">
                <input v-model="custom_field_1.fieldName" class="form-input cashback-input  mr-3" placeholder="field name">
                <label class="switch d-flex">
                  <input v-model="custom_field_1.required" type="checkbox" >
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="custom-fields col-12 pr-0 pl-0" v-for="(item, index) in custom_field_1.values" :key="index" >
                <div class="d-flex" v-if="custom_field_1.fieldName.length">
                  <input v-model="custom_field_1.values[index]" class="form-input cashback-input mb-2" placeholder="field value">
                  <button v-if="index == 0" type="button" @click="addNewVal('custom_field_1')" class="discount-btn ml-2"><img src="../../assets/icons/enable+.svg"></button>
                  <button v-if="index != 0" type="button" @click="removeVal('custom_field_1', index)" class="discount-btn ml-2"><img alt="x" src="../../assets/icons/x.svg"></button>
                </div>
              </div>
            </div>
            <h2 class="cashback-sub-title mt-3">Third field</h2>
            <div class="d-flex flex-wrap ">
              <div class="custom-fields col-12 pr-0 pl-0 d-flex align-items-center my-2">
                <input v-model="custom_field_2.fieldName" class="form-input cashback-input  mr-3" placeholder="field name">
                <label class="switch d-flex">
                  <input v-model="custom_field_2.required" type="checkbox" >
                  <span class="slider round"></span>
                </label>
              </div>
              <div class="custom-fields col-12 pl-0" v-for="(item, index) in custom_field_2.values" :key="index" >
                <div class="d-flex" v-if="custom_field_2.fieldName.length">
                  <input v-model="custom_field_2.values[index]" class="form-input cashback-input mb-2" placeholder="field value">
                  <button v-if="index == 0" type="button" @click="addNewVal('custom_field_2')" class="discount-btn ml-2"><img src="../../assets/icons/enable+.svg"></button>
                  <button v-if="index != 0" type="button" @click="removeVal('custom_field_2', index)" class="discount-btn ml-2"><img alt="x" src="../../assets/icons/x.svg"></button>
                </div>
              </div>
            </div>
            <br>
            <label class="sum-point">App version IOS (system settings)</label><br>
            <input v-model="app_version_ios" class="form-input cashback-input " placeholder="0.1.1">
            <label class="sum-point">App build IOS (system settings)</label><br>
            <input v-model="app_build_ios" class="form-input cashback-input " placeholder="10">
            <br>
            <label class="sum-point">App version Android (system settings)</label><br>
            <input v-model="app_version_android" class="form-input cashback-input " placeholder="0.2.2">
            <label class="sum-point">App build Android (system settings)</label><br>
            <input v-model="app_build_android" class="form-input cashback-input " placeholder="20">

          </div>
        </div>




      </div>
      <button type="button" @click="updateSettings" class="save">Save</button>
    </form>
  </div>
</template>

<script>
import Spinner from "../Spinner";
export default {
  name: "General",
  components:{
    Spinner
  },
  data(){
    return{
      spinner:true,
      currency:"",
      currencyRate:"",
      id: '',
      country:"",
      chat: false,
      notificate: false,
      name:'',
      email:'',
      mails: [],
      customFields: false,
      custom_field_0:{
        required: false,
        fieldName: '',
        values: ['']
      },
      custom_field_1:{
        required: false,
        fieldName: '',
        values: ['']
      },
      custom_field_2:{
        required: false,
        fieldName: '',
        values: ['']
      },
      app_version_ios:'',
      app_build_ios:'',
      app_version_android:'',
      app_build_android:'',
      authMethods: '',
      selectedMethod: ''
    }
  },
  methods:{
    cleanEmptyValues(field) {
      if (field.values.length > 0 && field.values[0] === '') {
        field.values.shift();
      }
      return field;
    },
    selectAuthMethod(selectedMethod) {
      Object.keys(this.authMethods).forEach(method => {
        // Set each method's enabled flag to true only if it matches the selected one.
        this.authMethods[method].enabled = (method === selectedMethod);
      });
      this.selectedMethod = selectedMethod
    },
    fieldClass(fieldName) {
      const currentMethod = this.authMethods[this.selectedMethod];
      if (!currentMethod[fieldName]) {
        // Field doesn't exist – mark as disabled.
        return ['reg-options', 'disabled'];
      }
      // Field exists – mark as active if enabled.
      return ['reg-options', { active: currentMethod[fieldName].enabled }];
    },
    toggleField(fieldName) {
      const currentMethod = this.authMethods[this.selectedMethod];
      const field = currentMethod[fieldName];
      // If the field doesn't exist or is required, do nothing.
      if (!field || field.required) {
        return;
      }
      // Toggle the enabled state.
      field.enabled = !field.enabled;
    },

    addNewMail() {
      if (this.newMail.trim()) {
        this.mails.push(this.newMail.trim());
        this.newMail = '';
      }
      console.log(this.mails)
    },
    addNewVal(field){
      this[field].values.unshift('')
    },
    removeVal(field, index) {
      if (field === 'mails') {
        this.mails.splice(index, 1);
      } else {
        this[field].values.splice(index, 1);
      }
    },
    updateSettings(){
      let that=this;
      let url = this.url('updateSettings');

      // Очищаем пустые значения перед отправкой
      const cleanedCustomField0 = this.cleanEmptyValues({ ...this.custom_field_0 });
      const cleanedCustomField1 = this.cleanEmptyValues({ ...this.custom_field_1 });
      const cleanedCustomField2 = this.cleanEmptyValues({ ...this.custom_field_2 });

      this.axios.put(url, {
        currency:this.currency,
        currencyRate:this.currencyRate,
        country:this.country,
        chat:this.chat,
        name:this.name,
        email:this.email,
        customFields: this.customFields,
        custom_field_0: cleanedCustomField0,
        custom_field_1: cleanedCustomField1,
        custom_field_2: cleanedCustomField2,
        orders_notification: this.notificate,
        mails: this.mails,
        app_version_ios: this.app_version_ios,
        app_build_ios: this.app_build_ios,
        app_version_android: this.app_version_android,
        app_build_android: this.app_build_android,
        authMethods: this.authMethods
      }).then(function (response) {
        console.log(response);
        that.$successAlert('Updated');
      }).catch(function(error){
        if (error.response) {
          if(error.response.data && !error.response.data.errors){
            that.$warningAlert(error.response.data.msg)
          }else{
            that.$warningAlert('Something went wrong');
          }

          that.$warningAlert(Object.values(error.response.data.errors),"Errors");
        }
      });
    },
    getDaysLeft(selectedDate){
      let today = this.$moment();
      let start = this.$moment(selectedDate).startOf('day');
      let end = this.$moment(today).startOf('day');
      return start.diff(end, 'days',true);
    },
    checkAccess1(){
      this.user_info = JSON.parse(localStorage.getItem('user'))
      let days_left = this.getDaysLeft(this.user_info.activeBefore)
      console.log("days_left", days_left)
      if (days_left <= 0) {
        this.$router.push({name: 'Price'})
    }
    }
  },
  mounted(){
    this.checkAccess1();
    // this.addActive()
  },
  beforeCreate(){
    let that = this;
    this.axios
        .get(this.url('getSettings'))
        .then(function (response){
          that.spinner = false;
          let settings = response.data.object;
          that.authMethods = settings.authMethods;
          that.selectedMethod = Object.keys(that.authMethods).find(
              key => that.authMethods[key].enabled
          );

          that.custom_field_0 = that.cleanEmptyValues(settings.custom_field_0);
          that.custom_field_1 = that.cleanEmptyValues(settings.custom_field_1);
          that.custom_field_2 = that.cleanEmptyValues(settings.custom_field_2);

          that.currency = settings.currency || '';
          that.id = settings._id;
          that.currencyRate = settings.currencyRate || 1;
          that.country = settings.country || '';
          that.chat = settings.chat || false;
          that.name = settings.name || '';
          that.email = settings.email || '';
          that.customFields = settings.customFields || false;
          if(!settings.custom_field_0.values.length){
            settings.custom_field_0.values = ['']
          }
          if(!settings.custom_field_1.values.length){
            settings.custom_field_1.values = ['']
          }
          if(!settings.custom_field_2.values.length){
            settings.custom_field_2.values = ['']
          }

          [that.custom_field_0, that.custom_field_1, that.custom_field_2].forEach(field => {
            if (field.values.length === 0) {
              field.values.push('');
            }
          });

          that.mails = settings.mails || [];
          that.notificate = settings.orders_notification || false;

          that.app_version_ios = settings.app_version_ios || '';
          that.app_build_ios = settings.app_build_ios || '';
          that.app_version_android = settings.app_version_android || '';
          that.app_build_android = settings.app_build_android || '';
        })

  },
}

</script>

<style scoped>
.discount-btn{
  height: 45px;
  flex: 0 0 45px;
  border-radius:5px;
  background: none;
  border: none;
}
.custom-fields .cashback-input{
  width: 80%;
}
.cashback-input{
  width: 100%;
}
.save{
  width: 120px;

}
.custom-fields .slider:before{
  bottom:1.5px;
}


.form input{
  width: 100%;
}
.cashback-title{
  margin-bottom: 20px;
}

.help-settings .cashback-input{
  width: 100%;
  margin-bottom: 15px;
}
.rm-question{
  position: absolute;
  right: -18px;
  top: 45%;
}
.add-more{
  color:#616cf5;
  display: inline-block;
  margin-bottom: 30px;
}
.left-general .cashback-input{
  margin-bottom: 20px;
}

.form-control{
  margin-bottom: 20px;
  font-size: 14px;
  color:#222;
  padding-left: 10px;
}
.validity-period{
  padding: 10px;
  border: 1px solid #D3D3D3;
  border-radius: 7px;
  cursor:pointer;
}
.reg-options{
  padding: 10px;
  border: 1px solid #D3D3D3;
  border-radius: 100px;
  cursor:pointer;
}
.validity-title{
  font-size: inherit;
  padding-left: 8px;
}
.month{
  width: 100%;
}
.round-price{
  width: 19px;
  height: 19px;
  background: #FFFFFF;
  border-radius:50%;
  display: flex;
  align-items:center;
  justify-content: center;
  border: 1px solid #D3D3D3;
}
.branch_list_item {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 22px;
  padding-bottom: 10px;
}
.validity-period.active{
  border: 1px solid #616cf5;
  transition: .3s;

}
.validity-period.active .round-price{
  background: #616cf5;
  border:none;
}
.reg-options.active{
  border: 1px solid #616cf5;
  transition: .3s;

}
.reg-options.active .round-price{
  background: #616cf5;
  border:none;
}
.reg-options.disabled{
  border: 1px solid #F5F5F5;
  transition: .3s;
  cursor: default;
  color: #F5F5F5;

}
.reg-options.disabled .round-price{
  border: 1px solid #F5F5F5;

}
.no-pointer {
  cursor: default;
  pointer-events: none;
}
/*




                            <div class="mb-4">
                              <p class="sum-point">Profile image</p>
                             <div class="profile-img">
                                  <img class="profile-logo" src="../../assets/icons/profile-img.svg">
                                  <input type="file" id="file" v-on:change="uploadPhoto">
                                  <label class="addPhoto" for="file"><img src="../../assets/icons/addBtn.svg"></label>
                             </div>
                            </div>



                <p class="sum-point">Working hours</p>
                <div class="d-flex mb-4">
                  <div style="width: 50%; margin-right:10px;" class="d-flex align-items-center">
                    <label>from:</label>
                    <select class="form-control form-control-lg " aria-label=".form-select-lg example">
                      <option value="01:00:00" selected="selected">01:00</option> <option value="01:15:00">01:15</option> <option value="01:30:00">01:30</option> <option value="01:45:00">01:45</option> <option value="02:00:00">02:00</option> <option value="02:15:00">02:15</option> <option value="02:30:00">02:30</option> <option value="02:45:00">02:45</option> <option value="03:00:00">03:00</option> <option value="03:15:00">03:15</option> <option value="03:30:00">03:30</option> <option value="03:45:00">03:45</option> <option value="04:00:00">04:00</option> <option value="04:15:00">04:15</option> <option value="04:30:00">04:30</option> <option value="04:45:00">04:45</option> <option value="05:00:00">05:00</option> <option value="05:15:00">05:15</option> <option value="05:30:00">05:30</option> <option value="05:45:00">05:45</option> <option value="06:00:00">06:00</option> <option value="06:15:00">06:15</option> <option value="06:30:00">06:30</option> <option value="06:45:00">06:45</option> <option value="07:00:00">07:00</option> <option value="07:15:00">07:15</option> <option value="07:30:00">07:30</option> <option value="07:45:00">07:45</option> <option value="08:00:00">08:00</option> <option value="08:15:00">08:15</option> <option value="08:30:00">08:30</option> <option value="08:45:00">08:45</option> <option value="09:00:00">09:00</option> <option value="09:15:00">09:15</option> <option value="09:30:00">09:30</option> <option value="09:45:00">09:45</option> <option value="10:00:00">10:00</option> <option value="10:15:00">10:15</option> <option value="10:30:00">10:30</option> <option value="10:45:00">10:45</option> <option value="11:00:00">11:00</option> <option value="11:15:00">11:15</option> <option value="11:30:00">11:30</option> <option value="11:45:00">11:45</option> <option value="12:00:00">12:00</option> <option value="12:15:00">12:15</option> <option value="12:30:00">12:30</option> <option value="12:45:00">12:45</option> <option value="13:00:00">13:00</option> <option value="13:15:00">13:15</option> <option value="13:30:00">13:30</option> <option value="13:45:00">13:45</option> <option value="14:00:00">14:00</option> <option value="14:15:00">14:15</option> <option value="14:30:00">14:30</option> <option value="14:45:00">14:45</option> <option value="15:00:00">15:00</option> <option value="15:15:00">15:15</option> <option value="15:30:00">15:30</option> <option value="15:45:00">15:45</option> <option value="16:00:00">16:00</option> <option value="16:15:00">16:15</option> <option value="16:30:00">16:30</option> <option value="16:45:00">16:45</option> <option value="17:00:00">17:00</option> <option value="17:15:00">17:15</option> <option value="17:30:00">17:30</option> <option value="17:45:00">17:45</option> <option value="18:00:00">18:00</option> <option value="18:15:00">18:15</option> <option value="18:30:00">18:30</option> <option value="18:45:00">18:45</option> <option value="19:00:00">19:00</option> <option value="19:15:00">19:15</option> <option value="19:30:00">19:30</option> <option value="19:45:00">19:45</option> <option value="20:00:00">20:00</option> <option value="20:15:00">20:15</option> <option value="20:30:00">20:30</option> <option value="20:45:00">20:45</option> <option value="21:00:00">21:00</option> <option value="21:15:00">21:15</option> <option value="21:30:00">21:30</option> <option value="21:45:00">21:45</option> <option value="22:00:00">22:00</option> <option value="22:15:00">22:15</option> <option value="22:30:00">22:30</option> <option value="22:45:00">22:45</option> <option value="23:00:00">23:00</option>
                    </select>
                  </div>

                  <div style="width: 50%;" class="d-flex align-items-center">
                    <label>to:</label>
                    <select class="form-control form-control-lg " aria-label=".form-select-lg example">
                      <option value="01:00:00" selected="selected">01:00</option> <option value="01:15:00">01:15</option> <option value="01:30:00">01:30</option> <option value="01:45:00">01:45</option> <option value="02:00:00">02:00</option> <option value="02:15:00">02:15</option> <option value="02:30:00">02:30</option> <option value="02:45:00">02:45</option> <option value="03:00:00">03:00</option> <option value="03:15:00">03:15</option> <option value="03:30:00">03:30</option> <option value="03:45:00">03:45</option> <option value="04:00:00">04:00</option> <option value="04:15:00">04:15</option> <option value="04:30:00">04:30</option> <option value="04:45:00">04:45</option> <option value="05:00:00">05:00</option> <option value="05:15:00">05:15</option> <option value="05:30:00">05:30</option> <option value="05:45:00">05:45</option> <option value="06:00:00">06:00</option> <option value="06:15:00">06:15</option> <option value="06:30:00">06:30</option> <option value="06:45:00">06:45</option> <option value="07:00:00">07:00</option> <option value="07:15:00">07:15</option> <option value="07:30:00">07:30</option> <option value="07:45:00">07:45</option> <option value="08:00:00">08:00</option> <option value="08:15:00">08:15</option> <option value="08:30:00">08:30</option> <option value="08:45:00">08:45</option> <option value="09:00:00">09:00</option> <option value="09:15:00">09:15</option> <option value="09:30:00">09:30</option> <option value="09:45:00">09:45</option> <option value="10:00:00">10:00</option> <option value="10:15:00">10:15</option> <option value="10:30:00">10:30</option> <option value="10:45:00">10:45</option> <option value="11:00:00">11:00</option> <option value="11:15:00">11:15</option> <option value="11:30:00">11:30</option> <option value="11:45:00">11:45</option> <option value="12:00:00">12:00</option> <option value="12:15:00">12:15</option> <option value="12:30:00">12:30</option> <option value="12:45:00">12:45</option> <option value="13:00:00">13:00</option> <option value="13:15:00">13:15</option> <option value="13:30:00">13:30</option> <option value="13:45:00">13:45</option> <option value="14:00:00">14:00</option> <option value="14:15:00">14:15</option> <option value="14:30:00">14:30</option> <option value="14:45:00">14:45</option> <option value="15:00:00">15:00</option> <option value="15:15:00">15:15</option> <option value="15:30:00">15:30</option> <option value="15:45:00">15:45</option> <option value="16:00:00">16:00</option> <option value="16:15:00">16:15</option> <option value="16:30:00">16:30</option> <option value="16:45:00">16:45</option> <option value="17:00:00">17:00</option> <option value="17:15:00">17:15</option> <option value="17:30:00">17:30</option> <option value="17:45:00">17:45</option> <option value="18:00:00">18:00</option> <option value="18:15:00">18:15</option> <option value="18:30:00">18:30</option> <option value="18:45:00">18:45</option> <option value="19:00:00">19:00</option> <option value="19:15:00">19:15</option> <option value="19:30:00">19:30</option> <option value="19:45:00">19:45</option> <option value="20:00:00">20:00</option> <option value="20:15:00">20:15</option> <option value="20:30:00">20:30</option> <option value="20:45:00">20:45</option> <option value="21:00:00">21:00</option> <option value="21:15:00">21:15</option> <option value="21:30:00">21:30</option> <option value="21:45:00">21:45</option> <option value="22:00:00">22:00</option> <option value="22:15:00">22:15</option> <option value="22:30:00">22:30</option> <option value="22:45:00">22:45</option> <option value="23:00:00">23:00</option>

                    </select>
                  </div>
                </div>







 <div class="addititon-settings">
                <div class="additional-item mb-4">
                  <div class="d-flex align-items-center mb-3">
                    <label class="switch d-flex">
                      <input type="checkbox" @click="disabled = (disabled + 1) % 2" >
                      <span class="slider round"><span class="enable">  Enable</span></span>
                    </label>
                  </div>

                  <h3 class="cashback-sub-title">Welcome point</h3>
                  <p class="cashback-description">A one-time award of points to the client for joining the company.</p>
                  <input class="cashback-input" placeholder="0">
                </div>
                <div class="additional-item mb-4">
                  <div class="d-flex align-items-center mb-3">
                    <label class="switch d-flex">
                      <input type="checkbox" @click="disabled = (disabled + 1) % 2" >
                      <span class="slider round"><span class="enable">  Enable</span></span>
                    </label>
                  </div>

                  <h3 class="cashback-sub-title">Share with a friend</h3>
                  <p class="cashback-description">Friends will share the link and receive a bonus on the account</p>
                  <input class="cashback-input" placeholder="0">
                </div>

                <div class="additional-item mb-4">
                  <div class="d-flex align-items-center mb-3">
                    <label class="switch d-flex">
                      <input type="checkbox" @click="disabled = (disabled + 1) % 2" >
                      <span class="slider round"><span class="enable">  Enable</span></span>
                    </label>


                  </div>
                  <h3 class="cashback-sub-title">Settings Delivery</h3>
                  <p class="cashback-description">Add shipping methods or shipping options</p>
                  <textarea class="general-area mb-5"></textarea>
                </div>

                <button class="save">Save </button>


              </div>
*/

</style>
